import React from "react";
import {Link, NavLink as NavLinkRRD } from "react-router-dom";

// reactstrap components
import {
  Card,
  CardBody,
  CardTitle,
  // Container,
  Row,
  Col,
  // Navbar,
  // Nav,
  Button,
  NavbarBrand,
  NavItem,
  NavLink
} from "reactstrap";
import { Navbar, Nav, Container } from 'react-bootstrap';
import TranslationLang from "components/Translation/TranslationLang";
import useCustomTranslation from "components/Translation/useCustomTranslation";

function HomeHeader() {
  const { t } = useCustomTranslation();

  return (
    <>
      <Navbar
        // className="navbar-top navbar-dark"
        // expand="md"
        // bg="light" variant="light"
        // bg="light" variant="light"
        // bg="white" variant="white"
        bg="white" variant="light"

        expand="sm"
        // id="navbar-main"
        fixed="top"
        collapseOnSelect
      // variant="dark"
      // bg="dark"
      >
        <Container fluid>

          <NavbarBrand to="/" tag={Link}
            className="py-4 px-5 flex h-24 items-center justify-center mr-auto my-2 rounded-lg origin-left exact-active active"

          >
            <img
              src={require("assets/img/brand/logo.png").default}
              style={{
                width: "200%",
                height: "200%",
                // width: 111,
                // height: 40,


                objectFit: "cover",
              }}
              alt="Responsive image"
            />
          </NavbarBrand>
          <Navbar.Toggle aria-controls='responsive-navbar-nav' />
          <Navbar.Collapse id='responsive-navbar-nav'>

            <Nav className="ml-auto">

            <NavItem>
                <NavLink
                  tag={NavLinkRRD}
                  // onClick={this.closeCollapse}
                  // activeClassName="active"
                  to="/home/homepage" >

                  {t`Home`}
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  tag={NavLinkRRD}
                  // onClick={this.closeCollapse}
                  // activeClassName="active"
                  to="/auth/register" >

                  {t`Register`}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={NavLinkRRD}
                  // onClick={this.closeCollapse}
                  // activeClassName="active"
                  to="/auth/login" >

                  {t`Login`}
                </NavLink>
              </NavItem>
            </Nav>
            <TranslationLang />
          </Navbar.Collapse>




        </Container>
      </Navbar>

    </>
  );
}

export default HomeHeader;
